// components/SudokuVsVideo.tsx - Sudoku Vs Game Rules video, served from the admin-managed API
import React, { useEffect, useState } from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuBasicsStyles/SudokuVideo.css';
import { useLanguage } from '../../../../../../Core/Translations/LanguageContext';
import Config from '../../../../../../Core/Config.json';

const API_URL = `${Config.apiBaseUrl}/api/Tutorial/GetActive`;
const CATEGORY = 'beginners-rules';
// Last-resort fallback if the API is unavailable (matches the previously hardcoded video).
const DEFAULT_VIDEO_ID = 'Cf29vw-yrHw';

const extractYouTubeId = (url: string): string => {
    if (!url) return '';
    const shorts = url.match(/shorts\/([^?&/\s]+)/);
    if (shorts) return shorts[1];
    const general = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
    return general ? general[1] : '';
};

const SudokuVsVideo = () => {
    const { language } = useLanguage();
    const [videoId, setVideoId] = useState<string>(DEFAULT_VIDEO_ID);
    const [title, setTitle] = useState<string>('Sudoku Tutorial Video');

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            try {
                const langCode = language || 'en';
                const response = await fetch(`${API_URL}?lang=${encodeURIComponent(langCode)}`);
                if (!response.ok) return;
                const data = await response.json();
                const videos = (data?.videos || []) as { title: string; videoUrl: string; category: string }[];
                const match = videos.find(v => (v.category || '').toLowerCase() === CATEGORY);
                if (!cancelled && match) {
                    const id = extractYouTubeId(match.videoUrl);
                    if (id) setVideoId(id);
                    if (match.title) setTitle(match.title);
                }
            } catch (err) {
                console.error('Error loading Sudoku Vs Game Rules video:', err);
            }
        };
        load();
        return () => { cancelled = true; };
    }, [language]);

    return (
        <div className="tutorial-step-container">
            <div className="video-placeholder">
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title={title}
                    allowFullScreen
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
                    className="video-iframe fullscreen-video"
                />

            </div>
        </div>
    );
};

export default SudokuVsVideo;
